export { TestimonialsComponent } from './testimonials'
